export { TestimonialsComponent } from './testimonials'
